import { render } from "./DamageItemList.vue?vue&type=template&id=e09d78e8"
import script from "./DamageItemList.vue?vue&type=script&lang=js"
export * from "./DamageItemList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__